import { BaseProductApi, ConflictAction } from '@inter-ikea-storageone/range';
import { ComponentIds, ConnectionUtils, ReplaceUtils } from '@inter-ikea-core/core';
import { fillSpace } from '../utils/fillSpace';
import BestaFrameComponent from './components/BestaFrameComponent';
export class BestaProductApi extends BaseProductApi {
    autoFillDoors(targets, entitiesToRemove, products) {
        entitiesToRemove.forEach((door) => {
            ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(door);
        });
        let placementResults = [];
        targets.forEach((frame) => {
            const size = frame.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
            if (!size) {
                return placementResults;
            }
            const variant = products.variants.find(v => v.communicatedDimensions.height <= size.height);
            if (variant && !isNaN(variant.dimensions?.width)) {
                placementResults.push(this.addToTarget(variant.coreProductId, frame));
                const allVariants = [...products.variants, ...products.defaults];
                const widthSpaceLeft = size.width - variant.dimensions.width;
                const heightSpaceLeft = size.height - variant.dimensions.height;
                if (widthSpaceLeft) {
                    placementResults = fillSpace(widthSpaceLeft, 'width', variant, allVariants, placementResults, frame, this.addToTarget.bind(this));
                }
                if (heightSpaceLeft) {
                    placementResults = fillSpace(heightSpaceLeft, 'height', variant, allVariants, placementResults, frame, this.addToTarget.bind(this));
                }
            }
        });
        return placementResults;
    }
    autoFillInnerLights(productId, targets, oldLights) {
        const replaceResults = [];
        oldLights.forEach((light) => {
            const result = this.replace(light.id, productId);
            if (result)
                replaceResults.push(result.replacedEntityResult);
        });
        const targetResults = targets.map((target) => this.addToTarget(productId, target));
        return [...replaceResults, ...targetResults];
    }
    performAction(action, params) {
        switch (action) {
            case ConflictAction.ADD_PRODUCT:
                this.add(params.productId, params.position);
                break;
            case ConflictAction.ADD_PRODUCT_TO_TARGET:
                {
                    const entity = this.coreServices.sceneManager.findEntity(params.parentEntityId);
                    if (!entity)
                        return;
                    const placementResult = this.addToTarget(params.productId, entity);
                    if (placementResult.valid &&
                        placementResult.placedEntity &&
                        params.entitiesToAddToCollidingEntityProductIds) {
                        params.entitiesToAddToCollidingEntityProductIds.forEach((productId) => {
                            if (!placementResult.placedEntity)
                                return;
                            this.addToTarget(productId, placementResult.placedEntity);
                        });
                    }
                }
                break;
            case ConflictAction.DELETE_ENTITY: {
                const entity = this.coreServices.sceneManager.findEntity(params.entityId);
                if (entity) {
                    ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(entity);
                }
                break;
            }
            case ConflictAction.ADD_ENTITY_TO_TARGET:
                {
                    const parentEntity = this.coreServices.sceneManager.findEntity(params.parentEntityId);
                    if (!parentEntity)
                        return;
                    const placementResult = this.placementService.snapToTarget(params.entity, parentEntity);
                    if (placementResult.valid && placementResult.placedEntity) {
                        this.placementService.dissolveEntity(placementResult.placedEntity);
                    }
                    if (placementResult.valid &&
                        placementResult.placedEntity &&
                        params.entitiesToAddToCollidingEntityProductIds) {
                        params.entitiesToAddToCollidingEntityProductIds.forEach((productId) => {
                            if (!placementResult.placedEntity)
                                return;
                            this.addToTarget(productId, placementResult.placedEntity);
                        });
                    }
                }
                break;
            default:
                throw new Error('Unkown action');
        }
    }
    /**
     * Due to Core issue https://r-e-x.slack.com/archives/C010KJCF1AP/p1744621717258919 we override the replace
     * function for BESTÅ and don't use fast replace for BESTÅ frame assemblies.
     * @override
     */
    replace(entityId, hostProductId, fastReplace = false, allowedMovementOfChildrenInMilliMeter = Number.MAX_VALUE) {
        const selectedEntity = this.coreServices.sceneManager.findEntity(entityId);
        const newEntity = this.coreServices.productManager.createEntity(hostProductId);
        if (!selectedEntity || !newEntity) {
            return null;
        }
        const isFrameAssembly = selectedEntity.hasComponent(BestaFrameComponent.id);
        const replacePlacementResult = fastReplace && !isFrameAssembly
            ? ReplaceUtils.fastReplaceEntity(selectedEntity, newEntity, this.coreServices)
            : ReplaceUtils.replaceEntity(selectedEntity, newEntity, allowedMovementOfChildrenInMilliMeter, this.coreServices);
        if (replacePlacementResult.replacedEntityResult.valid) {
            selectedEntity.dispose();
        }
        return replacePlacementResult;
    }
    /**
     *
     * @override
     */
    getDefaultLeg() {
        return 'pFramePad';
    }
}
//# sourceMappingURL=BestaProductApi.js.map